<template lang="pug">
v-container(fluid class="pt-0 mt-0")
    v-row(dense)
        v-col(cols="12")
            v-data-table(
                :headers="headers"
                :items="localPoints"
                item-key="id"
                class="custom-table"

            )

                template(v-slot:item.standard_uom_id="{ item }")
                    | {{ getUomName(item.standard_uom_id) }}
                template(v-slot:item.is_finalized="{ item }")
                    v-icon(
                        :color="item.is_finalized ? 'green' : 'red'"
                    )
                        | {{ item.is_finalized ? 'check' : 'close' }}
                template(v-slot:item.actions="{ item }")
                    //- need more room so that these icons are on same line
                    v-icon(@click="editPoint(item)" color="brand" small).mr-2 edit
                    v-icon(@click="deletePoint(item)" color="red" small) delete
                template(v-slot:top)
                    v-toolbar(flat)
                        v-spacer
                        v-dialog(
                            v-model='editDialog'
                            max-width='550px'
                            light
                        )
                            v-card(light)
                                v-card-title
                                    span.text-h5 Edit Point
                                v-card-subtitle
                                    span {{ editedItem.point_name }}
                                v-card-text
                                    v-form(
                                        ref="pointEditForm"
                                        v-model="valid"
                                    )
                                        v-container
                                            v-row
                                                v-col(cols="12" sm="6" md="4")
                                                    v-select(
                                                        v-model="editedItem.point_type"
                                                        :items="availablePointTypes"
                                                        label="Point Type"
                                                        color="brand"
                                                        @change="handlePointTypeChange"
                                                        :rules="[rules.required]"
                                                    )
                                                v-col(cols="12" sm="6" md="8" v-if="editedItem.point_type === 'CALC'")
                                                    v-text-field(
                                                        v-model.trim="editedItem.point_name"
                                                        label="Point Name"
                                                        :rules="[rules.required, rules.minLength5]"
                                                        color="brand"
                                                        hint="Must be at least 5 characters"
                                                        persistent-hint
                                                    )
                                                v-col(cols="12" sm="6" md="4")
                                                    v-text-field(
                                                        v-model.trim="editedItem.source_uom"
                                                        label="UOM (sys)"
                                                        :rules="[rules.required]"
                                                        readonly
                                                        color="brand"
                                                        hint='read-only'
                                                        persistent-hint
                                                    )
                                                v-col(cols="12" sm="6" md="4" v-if="editedItem.point_type === 'PERCENT'")
                                                    v-text-field(
                                                        v-model.number="editedItem.conversion_factor"
                                                        label="Conversion Factor"
                                                        type="number"
                                                        :rules="[rules.required, rules.minOne]"
                                                        min="1"
                                                        color="brand"
                                                        hint="Number >= 1"
                                                        persistent-hint
                                                    )
                                                v-col(cols="12" sm="6" md="4" v-if="editedItem.point_type !== 'CALC'")
                                                    v-select(
                                                        v-model="editedItem.standard_uom_id"
                                                        label="UOM (std)"
                                                        :items="filteredUnits"
                                                        item-text="uom_code"
                                                        item-value="id"
                                                        :rules="[rules.required]"
                                                        color="brand"
                                                    )
                                                v-col(cols="12" sm="6" md="4" v-else)
                                                    v-select(
                                                        v-model="editedItem.standard_uom_id"
                                                        label="UOM (std)"
                                                        :items="filteredUnits"
                                                        item-text="uom_code"
                                                        item-value="id"
                                                        :rules="[rules.required]"
                                                        color="brand"
                                                        readonly
                                                        hint="readonly for CALC points"
                                                        persistent-hint
                                                    )
                                            v-row(v-if="editedItem.point_type === 'CALC'")
                                                v-col(cols="12")
                                                    v-select(
                                                        v-model="editedItem.calculation_point_ids.storage"
                                                        :items="storageCategoryPoints"
                                                        item-text="name"
                                                        item-value="id"
                                                        label="Storage Points"
                                                        multiple
                                                        outlined
                                                        color="brand"
                                                        hint="Select one or more finalized AS-IS points."
                                                        ref="storagePointsSelect"
                                                        class="light-select"
                                                        :rules="[rules.nonEmptyArray]"
                                                    )
                                            v-row(v-if="editedItem.point_type === 'CALC'")
                                                v-col(cols="12")
                                                    v-select(
                                                        v-model="editedItem.calculation_point_ids.production"
                                                        :items="productionCategoryPoints"
                                                        item-text="name"
                                                        item-value="id"
                                                        label="Production Points"
                                                        multiple
                                                        outlined
                                                        color="brand"
                                                        hint="Select one or more finalized AS-IS points."
                                                        ref="productionPointsSelect"
                                                        class="light-select"
                                                        :rules="[rules.nonEmptyArray]"
                                                    )

                                            v-row(v-if="editedItem.point_type !== 'CALC'")
                                                v-col(cols="12" sm="6" md="4")
                                                    v-select(
                                                        v-model="editedItem.container_type"
                                                        :items="['NONE', 'BOX', 'CYLINDER', 'SPHERE']"
                                                        label="Container Type"
                                                        color="brand"
                                                        @change="handleContainerTypeChange"
                                                    )
                                                v-col(cols="12" sm="6" md="4" v-if="editedItem.container_type !== 'NONE'")
                                                    v-select(
                                                        v-model="editedItem.container_dimensions_uom_id"
                                                        :items="linearUnits"
                                                        item-text="uom_code"
                                                        item-value="id"
                                                        label="Dimensions UOM"
                                                        :rules="[rules.required]"
                                                        color="brand"
                                                    )

                                            v-row(v-if="editedItem.point_type !== 'CALC'")
                                                //- Container dimensions based on type
                                                template(v-if="editedItem.container_type === 'BOX'")
                                                    v-col(cols="12" sm="6" md="4")
                                                        v-text-field(
                                                            v-model.number="editedItem.container_dimensions.length"
                                                            label="Length"
                                                            type="number"
                                                            color="brand"
                                                            :rules="[rules.required, rules.gtZero]"
                                                        )
                                                    v-col(cols="12" sm="6" md="4")
                                                        v-text-field(
                                                            v-model.number="editedItem.container_dimensions.width"
                                                            label="Width"
                                                            type="number"
                                                            color="brand"
                                                            :rules="[rules.required, rules.gtZero]"
                                                        )
                                                    v-col(cols="12" sm="6" md="4")
                                                        v-text-field(
                                                            v-model.number="editedItem.container_dimensions.height"
                                                            label="Height"
                                                            type="number"
                                                            color="brand"
                                                            :rules="[rules.required, rules.gtZero]"
                                                        )
                                                template(v-if="editedItem.container_type === 'CYLINDER'")
                                                    v-col(cols="12" sm="6" md="4")
                                                        v-text-field(
                                                            v-model.number="editedItem.container_dimensions.radius"
                                                            label="Radius"
                                                            type="number"
                                                            color="brand"
                                                            :rules="[rules.required, rules.gtZero]"
                                                        )
                                                    v-col(cols="12" sm="6" md="4")
                                                        v-text-field(
                                                            v-model.number="editedItem.container_dimensions.height"
                                                            label="Height"
                                                            type="number"
                                                            color="brand"
                                                            :rules="[rules.required, rules.gtZero]"
                                                        )
                                                template(v-if="editedItem.container_type === 'SPHERE'")
                                                    v-col(cols="12" sm="6" md="4")
                                                        v-text-field(
                                                            v-model.number="editedItem.container_dimensions.radius"
                                                            label="Radius"
                                                            type="number"
                                                            color="brand"
                                                            :rules="[rules.required, rules.gtZero]"
                                                        )
                                            v-row
                                                template(v-if="editedItem.is_finalized")
                                                    v-col(cols="12" sm="6" md="7")
                                                        v-text-field(
                                                            v-model="editedItem.finalized_by"
                                                            label="Finalized By"
                                                            readonly
                                                            color="brand"
                                                            disabled
                                                        )
                                                    v-col(cols="12" sm="6" md="5")
                                                        v-text-field(
                                                            v-model="formattedFinalizationDate"
                                                            label="Finalized On"
                                                            readonly
                                                            color="brand"
                                                            disabled
                                                        )
                                v-card-actions
                                    v-btn(
                                        @click="finalizePoint"
                                        color="red darken-1"
                                        :disabled="!canFinalize"
                                        text
                                    ) Finalize
                                    v-btn(
                                        @click="unFinalizePoint"
                                        :disabled="!editedItem.is_finalized"
                                        color="orange darken-1"
                                        text
                                    ) Unfinalize
                                    v-spacer
                                    v-btn(
                                        color="blue darken-1"
                                        text
                                        @click="closeDialog"
                                    ) Cancel
                                    v-btn(
                                        color="blue darken-1"
                                        text
                                        @click="savePoint"
                                        :disabled="!canSave"
                                    ) Save
        v-dialog(
            v-model="deleteDialog"
            max-width="500px"
        )
            v-card(light style="width: 100%;")
                v-card-title.text-h5 Delete Point
                v-card-text Are you sure you want to delete this point?
                v-card-actions
                    v-spacer
                    v-btn(
                        color="blue darken-1"
                        text
                        @click="closeDeleteDialog"
                    ) Cancel
                    v-btn(
                        color="red darken-1"
                        text
                        @click="deletePointConfirm"
                    ) Delete


</template>

<script lang="js">

import cloneDeep from 'lodash/cloneDeep';
const POINT_TYPE = {
    AS_IS: 'AS_IS',
    PERCENT: 'PERCENT',
    CALC: 'CALC'
};
export default {
    name: 'Point',
    emits: ['update:points'],
    props: {
        category: {
            type: Object,
            required: true
        },
        uom: {
            type: Array,
            required: true
        },
        categories: {
            type: Array,
            required: true
        }
    },
    data () {
        return {
            localPoints: cloneDeep(this.category.points),
            headers: [
                { text: 'Point Name', value: 'point_name'},
                { text: 'UOM', value: 'standard_uom_id' },
                { text: 'Status', value: 'server_status' },
                { text: 'Type', value: 'point_type'},
                { text: 'Finalized', value: 'is_finalized' },
                { text: 'Actions', value: 'actions', sortable: false },
            ],
            editDialog: false,
            valid: false,
            rules: {
                required: (value) => !!value || 'Required.',
                gtZero: (value) => value > 0 || 'Value must be greater than 0.',
                minOne: (value) => Number(value) >= 1 || 'Must be 1 or more.',
                minLength5: (value) => !value || value.trim().length >= 5 || 'Must be at least 5 characters.',
                nonEmptyArray: (value) => Array.isArray(value) && value.length > 0 || 'Select at least one point.'
            },
            editedItem: {},
            deleteDialog: false,
            itemToDelete: null,
            showPointDialog: false,
            textareaCursorPos: 0,
        };
    },
    watch: {
        category: {
            handler (newVal) {
                // use vue reactive
                this.localPoints = cloneDeep(newVal.points);
            },
            deep: true,
            immediate: true
        },
        editedItem: {
            handler () {
                if(this.$refs['pointEditForm']) {
                    this.$refs.pointEditForm.resetValidation();
                    this.$refs.pointEditForm.validate();
                    if(!this.valid && this.editedItem.is_finalized) {
                        this.unFinalizePoint();
                    }
                }
            },
            deep: true
        }
    },
    computed: {
        categoryName () {
            return this.category?.name || 'Unknown Category';
        },
        formattedFinalizationDate () {
            if (!this.editedItem.finalized_date) return '';
            return new Date(this.editedItem.finalized_date).toLocaleString();
        },
        linearUnits () {
            return this.uom.filter(unit => unit.type === 'LINEAR');
        },
        volumeUnits () {
            return this.uom.filter(unit => unit.type === 'VOLUME');
        },
        nonLinearUnits () {
            return this.uom.filter(unit => unit.type === 'VOLUME' || unit.type === 'RATE');
        },
        rateUnits () {
            return this.uom.filter(unit => unit.type === 'RATE');
        },
        filteredUnits () {
            // CALC uses rate units
            if (this.editedItem.point_type === POINT_TYPE.CALC) {
                return this.rateUnits;
            }

            // PERCENT must use volume units
            if (this.editedItem.point_type === POINT_TYPE.PERCENT) {
                return this.volumeUnits;
            }

            // For AS_IS, mapping depends on category
            if (this.editedItem.point_type === POINT_TYPE.AS_IS) {
                const catName = this.category && this.category.category_name;
                if (catName === 'DEMAND' || catName === 'PRODUCTION') {
                    return this.rateUnits;
                }
                if (catName === 'CONSUMPTION' || catName === 'STORAGE') {
                    return this.volumeUnits;
                }
                // fallback to original behavior
                return this.editedItem.container_type === 'NONE' ? this.nonLinearUnits : this.volumeUnits;
            }

            // default fallback
            return this.editedItem.container_type === 'NONE' ? this.nonLinearUnits : this.volumeUnits;
        },
        /**
         * finalized production AS-IS points sorted ascending by point_id
         */
        productionCategoryPoints () {
            return this.getSortedCategoryPoints('PRODUCTION');
        },
        /**
         * finalized storage AS-IS points sorted ascending by point_id
         */
        storageCategoryPoints () {
            return this.getSortedCategoryPoints('STORAGE');
        },
        canFinalize () {
            return this.valid && !this.editedItem.is_finalized;
        },
        canSave () {
            return this.valid;
        },
        availablePointTypes () {
            const types = ['AS_IS'];
            // PERCENT only available for STORAGE categories
            if (this.category && this.category.category_name === 'STORAGE') {
                types.push('PERCENT');
            }
            // CALC only available for DEMAND categories
            if (this.category && this.category.category_name === 'DEMAND') {
                types.push('CALC');
            }
            return types;
        },
    },
    methods: {
        emitPointsUpdate () {
            this.$emit('update:points', {
                category_id: this.category.id,
                points: cloneDeep(this.localPoints)
            });
        },

        getUomName (uom_id) {
            const uom = this.uom.find(uom => uom.id === uom_id);
            return uom ? uom.uom_code : 'Unknown UOM';
        },

        handleContainerTypeChange () {
            // Reset dimensions when container type changes
            this.editedItem.container_dimensions = {
                length: null,
                width: null,
                height: null,
                radius: null
            };
        },

        handlePointTypeChange () {
            // When switching to CALC ensure container dims are cleared and calculation ids exist
            if (this.editedItem.point_type === POINT_TYPE.CALC) {
                this.editedItem.container_type = 'NONE';
                this.editedItem.container_dimensions = {
                    length: null,
                    width: null,
                    height: null,
                    radius: null
                };
                if (!this.editedItem.calculation_point_ids) {
                    this.$set(this.editedItem, 'calculation_point_ids', { storage: [], production: [] });
                }
                // ensure standard uom matches category when CALC
                if (this.category && this.category.standard_uom_id) {
                    this.editedItem.standard_uom_id = this.category.standard_uom_id;
                }
            } else if (this.editedItem.point_type === POINT_TYPE.PERCENT) {
                // initialize conversion factor for PERCENT
                if (this.editedItem.conversion_factor == null) {
                    this.editedItem.conversion_factor = 1;
                }
            } else {
                // clear calculation selections for non-CALC types
                if (this.editedItem.calculation_point_ids) {
                    this.editedItem.calculation_point_ids.storage = [];
                    this.editedItem.calculation_point_ids.production = [];
                }
                // if leaving PERCENT type, keep the value but it's optional to clear
            }
        },

        editPoint (item) {
            this.editedItem = {
                ...item,
                container_dimensions: item.container_dimensions || {},
                calculation_point_ids: item.calculation_point_ids || {}
            };
            // if opening a CALC point, ensure its standard_uom_id aligns with the category
            if (this.editedItem.point_type === POINT_TYPE.CALC && this.category && this.category.standard_uom_id) {
                this.editedItem.standard_uom_id = this.category.standard_uom_id;
            }
            // if opening a PERCENT point, ensure conversion_factor exists
            if (this.editedItem.point_type === POINT_TYPE.PERCENT && this.editedItem.conversion_factor == null) {
                this.editedItem.conversion_factor = 1;
            }
            this.editDialog = true;
        },

        deletePoint (item) {
            this.itemToDelete = item;
            this.deleteDialog = true;
        },

        closeDeleteDialog () {
            this.deleteDialog = false;
            this.itemToDelete = null;
        },

        deletePointConfirm () {
            if (
                this.itemToDelete == null ||
                this.itemToDelete.point_id === undefined ||
                this.itemToDelete.point_type === undefined
            ) {
                // Optionally, show a warning or log an error here
                this.closeDeleteDialog();
                return;
            }
            const index = this.localPoints.findIndex(
                pt =>
                    pt.point_id === this.itemToDelete.point_id &&
                    pt.point_type === this.itemToDelete.point_type
            );
            if (index > -1) {
                this.$set(this.localPoints, index, undefined);
                this.localPoints.splice(index, 1);
            }

            this.emitPointsUpdate();
            this.closeDeleteDialog();
        },

        closeDialog () {
            this.editDialog = false;
        },

        savePoint () {
            if (this.editedItem.point_id) {
                const index = this.localPoints.findIndex(pt => pt.point_id === this.editedItem.point_id && pt.point_type === this.editedItem.point_type);
                if (index > -1) {
                    this.$set(this.localPoints, index, cloneDeep(this.editedItem));
                    console.log('Updated existing point:', this.editedItem);
                    this.emitPointsUpdate();
                }
            }

            this.closeDialog();

        },

        finalizePoint () {
            if (!this.editedItem.is_finalized && this.valid) {
                this.editedItem.is_finalized = true;
                this.editedItem.finalized_by = this.$store.getters.userEmail;
                this.editedItem.finalized_date = new Date();
            }

            // Update point without closing dialog
            if (this.editedItem.point_id ) {
                const index = this.localPoints.findIndex(pt => pt.point_id === this.editedItem.point_id && pt.point_type === this.editedItem.point_type);
                if (index > -1) {
                    this.$set(this.localPoints, index, {...this.editedItem});
                    // this.emitPointsUpdate();
                }
            }
        },
        unFinalizePoint () {
            if (this.editedItem.is_finalized) {
                this.editedItem.is_finalized = false;
                this.editedItem.finalized_by = null;
                this.editedItem.finalized_date = null;

                // Update point without closing dialog
                if (this.editedItem.point_id) {
                    const index = this.localPoints.findIndex(pt => pt.point_id === this.editedItem.point_id && pt.point_type === this.editedItem.point_type);
                    if (index > -1) {
                        this.$set(this.localPoints, index, {...this.editedItem});
                        // this.emitPointsUpdate();
                    }
                }
            }
        },
        getSortedCategoryPoints (catName) {
            const cat = this.categories.find(cat => cat.category_name === catName);
            if (!cat) return [];
            const points = cat.points.reduce((acc, pt) => {
                if (pt.is_finalized && (pt.point_type === POINT_TYPE.AS_IS || pt.point_type === POINT_TYPE.PERCENT)) {
                    acc.push({ name: pt.point_name, id: pt.point_id });
                }
                return acc;
            }, []);
            points.sort((a, b) => a.point_id - b.point_id);
            return points;
        },
    },
};
</script>

<style lang="scss" scoped>
header {
  margin: 0 !important;
  padding: 0 !important;
  height: auto !important;
}
</style>
